import { useCallback } from "react"

import { isEqual, transform } from "lodash"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { DocumentForm } from "../../forms/DocumentForm/DocumentForm"
import { useDocumentUpdate } from "../../hooks/mutations/useDocumentUpdate"

export const DocumentEditForm = (props) => {
    const {
        document,
        onClose,
        onSubmitting,
        onChange,
        selectionType,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const mutation = useDocumentUpdate(document, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.documentEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.documentEditForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: () => {
            onSubmitting(false)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = transform(formValues, (result, value, key) => {
            if (key === "file") {
                if (value?.file !== document?.file) {
                    result[key] = value
                }
            } else if (!isEqual(value, document?.[key])) {
                result[key] = value
            }
        }, {})
        mutation.mutate({
            ...values,
            ...(selectionType && { attached_object_content_type: selectionType }),
        })
        onSubmitting(true)
    }, [mutation, onSubmitting, document, selectionType])

    return <DocumentForm
        document={document}
        isSubmitting={mutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}

DocumentEditForm.propTypes = {
    document: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmitting: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
}